import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import SvgIcon from '@material-ui/core/SvgIcon';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function InvestorsIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M11.0854 4H13.9146C13.7087 3.4174 13.1531 3 12.5 3C11.8469 3 11.2913 3.4174 11.0854 4ZM15.9646 4H21C22.6569 4 24 5.34315 24 7V19C24 20.6569 22.6569 22 21 22H4C2.34315 22 1 20.6569 1 19V7C1 5.34315 2.34315 4 4 4H9.03544C9.27806 2.30385 10.7368 1 12.5 1C14.2632 1 15.7219 2.30385 15.9646 4ZM7 11C7 10.4477 7.44772 10 8 10L17 10C17.5523 10 18 10.4477 18 11C18 11.5523 17.5523 12 17 12L8 12C7.44772 12 7 11.5523 7 11Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<InvestorsIcon fill={props.fill} />
		</div>
	);
}